import defaultReducers from '@models/defaultReducers'
import { transformCharts } from '@src/models/dailyCharts/chart.transforms'
import { DailyChartsStoreState } from './types'
import { defaultDailyChartsState } from './constants'

const reducers = {
  ...defaultReducers,

  setChartsData: (state: DailyChartsStoreState, { payload }: { payload: any }) => {
    return {
      ...state,
      charts: {
        ...defaultDailyChartsState.charts,
        ...transformCharts(payload.charts),
      },
    }
  },
}

export default reducers
